export const ocTranslationsHu = {
  OC_RECORDING_NOT_ALLOWED: "A rögzítés nem megengedett!",
  OC_EMPLOYEE_REQUESTS: "Dolgozó kérelmei",
  OC_REQUESTS_DETAILS: "Kérelem részletei",
  OC_CONFIRM_GO_BACK_TEXT: "Valóban visszalép az adatok mentése nélkül?",
  OC_CONFIRM_GO_BACK: "Visszalépés megerősítése",
  OC_START_TIME: "Kezdete",
  OC_END_TIME: "Vége",
  OC_DATE_IN_FUTURE: "A megadott kezdő- és/vagy végdátum a mai napnál későbbi nem lehet!",
  OC_START_DATE_REQUIRED: "A kezdő dátum megadása kötelező!",
  OC_END_DATE_REQUIRED: "A végdátum megadása kötelező!",
  OC_FILTER: "Szűrő",
  OC_REQUESTS_VIEW: "Kérelmek megtekintése",
  OC_APPROVE_REQUESTS: "Kérelmek elbírálása",
  OC_END_DATE: "Vége dátum",
  OC_START_DATE: "Kezdő dátum",
  OC_NOT_PROVIDED: "Nincs megadva",
  OC_TEMPORARY_ERROR_TEXT: "Átmeneti kapcsolati probléma, kérjük, próbálja meg később.",
  OC_END_DATE_BEFORE_START_DATE: "A befejezés dátuma korábbi, mint a kezdés dátuma!",
  OC_DELETE_CONFIRM: "Törlés megerősítése",
  OC_UPLOAD_FAILED: "Sikertelen feltöltés",
  OC_FILE_UPLOAD_SIZE_FAILED: "A fájl mérete túl nagy (maximum 9MB)",
  OC_DESIGNATION: "Megnevezés",
  OC_INCORRECT_FORMAT: "Nem megfelelő formátum!",
  OC_ALL_APPROVE: "Mindet elfogad",
  OC_ALL_APPROVE_FAILED: "A tételek elfogadása sikertelen volt",
  OC_OVERLAPPING_TIME_PERIODS: "A kérelem létrehozása átfedés miatt sikertelen",
  OC_HOUR: "Óra",
  OC_REQUESTS: "Kérelmek",
  OC_TOO_MANY_HITS: "Túl sok találat! Kérem szűkítsen a feltételeken",
  OC_EMPTY: "Nem beállított",
  OC_GENERAL_SETTINGS: "Általános beállítások",
  OC_NOTE: "Megjegyzés",
  OC_ACTIVE: "Aktív",
  OC_ADD: "Hozzáad",
  OC_ALL: "Összes",
  OC_APPROVE: "Elfogad",
  OC_CALENDAR: "Naptár",
  OC_CANCEL: "Mégsem",
  OC_COMPANY: "Cég",
  OC_DELETE: "Törlés",
  OC_ERROR_MESSAGE_EMAIL_IS_REQUIRED: "Az email megadása kötelező!",
  OC_ERROR_MESSAGE_FIELD_IS_REQUIRED: "Kötelező mező!",
  OC_ERROR_TEXT: "Váratlan hiba történt a komponens megjelenítése közben.",
  OC_IMAGE: "Kép",
  OC_LOADING: "Adatok betöltése...",
  OC_MENU: "Menü",
  OC_MODULE: "Modul",
  OC_MONTH: "hónap",
  OC_MONTHS: "hónap",
  OC_NAME: "Név",
  OC_NEXT: "Tovább",
  OC_OPTIONAL: "(Opcionális)",
  OC_ORGUNIT: "Szervezeti egység",
  OC_JOBCLASSGROUP: "Munkaköri csoport",
  OC_WORKINGPLACE: "Munkahely",
  OC_GET_EMPLOYEE: "Dolgozó",
  OC_SHIFT_TYPE: "Műszak típusa",
  OC_PAYOFFICE: "Kifizetőhely",
  OC_PERIOD: "Időszak",
  OC_PRINT: "Nyomtatás",
  OC_REJECT: "Elutasít",
  OC_RELOAD_PAGE: "oldal újratöltése",
  OC_REQUEST_CREATED_AT: "Kérelem időpontja",
  OC_REQUEST: "Kérelem",
  OC_ROLE: "Szerep",
  OC_SAVE: "Mentés",
  OC_SETTINGS: "Beállítások",
  OC_STATE: "Állapot",
  OC_TABLE: "Táblázat",
  OC_TO_BE_ASSESSED: "Elbírálandó",
  OC_TYPE: "Típus",
  OC_USER_UPDATED: "Az adatok sikeresen elmentve",
  OC_VALID_FROM: "Érvényesség kezdete",
  OC_VALID_TO: "Érvényesség vége",
  OC_VALIDITY: "Érvényesség",
  OC_WORKDAYS: "munkanap",
  OC_YEAR: "év",
  OC_YEARS: "év",
  OC_FILTERING: "Szűrés",
  OC_COUNT_OF_EMPLOYEES: "Dolgozók száma",
  OC_RESET: "Visszaállítás",
  OC_SAVE_FAILED: "Hiba történt az adatok mentése közben!",
  OC_PROPERTY_SAVE_SUCCEEDED: "Az adat sikeresen elmentve!",
  OC_PROPERTY_SAVE_FAILED: "Az adat mentése nem sikerült!",
  OC_REVOKE_REQUEST_CONFIRM: "Biztosan vissza szeretné vonni a kérelmét?",
  OC_ALL_RIGHT: "Rendben",
  OC_DOWNLOADS: "Letöltések",
  OC_ERROR: "Hiba leírása",
  OC_CALENDAR_DATE: "Dátum",
  OC_CALENDAR_TIME: "Időpont",
  OC_CALENDAR_EVENT: "Esemény",
  OC_CALENDAR_ALL_DAY: "Egész nap",
  OC_CALENDAR_WEEK: "Hét",
  OC_CALENDAR_WORK_WEEK: "Munkahét",
  OC_CALENDAR_DAY: "Nap",
  OC_CALENDAR_MONTH: "Hónap",
  OC_CALENDAR_PREVIOUS: "Előző",
  OC_CALENDAR_NEXT: "Következő",
  OC_CALENDAR_YESTERDAY: "Tegnap",
  OC_CALENDAR_TOMORROW: "Holnap",
  OC_TODAY: "Ma",
  OC_CALENDAR_AGENDA: "Agenda",
  OC_CALENDAR_NO_EVENTS_IN_RANGE: "Nincsenek események ebben az időszakban",
  OC_CALENDAR_MORE: "még",
  OC_BACK: "Vissza",
  OC_FINISH: "Befejezés",
  OC_AMOUNT: "Összeg",
  OC_COST: "Költség",
  OC_NOT_SELECTED: "nincs kiválasztva",
  OC_REFRESH: "Frissítés",
  OC_EMPLOYEE_NAME: "Dolgozó neve",
  OC_UPLOAD: "Feltöltés",
  OC_DRAG_AND_DROP_FILE: "Húzza be a fájlt, vagy kattintson ide",
  OC_CONNECTION_ERROR: "Nincs kapcsolat a szerverrel.",
  OC_DB_CONNECTION_ERROR: "Nincs kapcsolat az adatbázissal.",
  OC_DAY: "nap",
  OC_DATE: "Dátum",
  OC_NEW: "Új",
  OC_OLD: "Régi",
  OC_NO_RESULTS: "Nincs találat",
  OC_MESSAGES: "Üzenetek",
  OC_EXAMINERS: "Elbíráló(k)",
  OC_ROLE_EXAMINERS: "A szerephez tartozó elbíráló(k):",
  OC_ROLE_EDITORS: "A szerephez tartozó szerkesztő(k):",
  OC_ROLE_ASSIGNERS: "A szerephez tartozó kiíró(k):",
  OC_MISSING_EXAMINERS: "Nincs beállított elbíráló",
  OC_MISSING_EDITORS: "Nincs beállított szerkesztő",
  OC_MISSING_ASSIGNERS: "Nincs beállított kiíró",
  OC_COUNT_OF_REQUESTS: "Kérelmek száma",
  OC_EMPTY_MESSAGE: "Üres üzenet nem küldhető el!",
  OC_CONFIRM_SETTING: "Beállítás megerősítése",
  OC_CONFIRM_SETTING_INFO: "Valóban megváltoztatja a beállítást?",
  OC_MY_ROLES_EXAMINEES: "Szerephez tartozó dolgozók",
  OC_MORE: "Bővebben",
  OC_NOT_SET_EXAMINER_INFO: "Önnek nincs beállított elbírálója, ezért ez a funkció nem elérhető",
  OC_TOTAL_COUNT_OF_EMPLOYEES: "Dolgozók száma összesen",
  OC_OPERATION_SUCCESSFUL: "A művelet sikeres",
  OC_OPERATION_UNSUCCESSFUL: "A művelet sikertelen",
  OC_MODIFY: "Módosítás",
  OC_EMPLOYEES: "Dolgozók",
  OC_REQUESTED: "Kérelmezve",
  OC_APPROVED: "Elfogadva",
  OC_REJECTED: "Elutasítva",
  OC_WRITE_MESSAGE: "Üzenet írása...",
  OC_NOT_SELECTABLE: "Nem kiválasztható!",
  OC_MESSAGE: "Üzenet",
  OC_SUMMARY: "Összesen",
  OC_REMOVE_REQUEST: "Visszavon",
  OC_REQUESTED_PAST: "Kérelmezett",
  OC_ABSENCE: "Távollét",
  OC_NAME_REQUIRED: "A név megadása kötelező!",
  OC_UNSUCCESSFULLY_SAVED: "Hiba lépett fel az adat(ok) mentése közben!",
  OC_DATE_TOO_FAR_AWAY: "A megadott kezdő- és/vagy végdátum a mai naphoz képest túl távoli!",
  OC_VIEWS: "Megtekintés",
  OC_PAGE: "Oldal",
};
